export default __webpack_public_path__ + "static/media/red.d80fcac9.png";